export default "__VITE_ASSET__CRvtjFH6__"